import React from "react";
import { useNavigate } from "react-router-dom";

function NavLink({ to, icon, children }) {
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isActive = location === to || (to !== "/" && location.startsWith(to));
  
  return (
    <button
      onClick={() => navigate(to)}
      className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
        isActive 
          ? "bg-deflorencia text-white font-medium" 
          : "text-slate-700 hover:bg-slate-100"
      }`}
    >
      {icon}
      <span>{children}</span>
    </button>
  );
}

export default NavLink;
